import { useState, useEffect } from "react";
import axios from "axios";
import { Check, Loader2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SubmitApplication({ t, token, allSigned, formRef, alreadySubmitted }) {
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const [confirmed, setConfirmed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(!!alreadySubmitted);
  const [err, setErr] = useState("");
  useEffect(() => { if (alreadySubmitted) setSubmitted(true); }, [alreadySubmitted]);

  const submitApplication = async () => {
    setErr("");
    const form = formRef?.current;
    if (form && !form.ok) { setErr(t.fillFormFirst || "Doplňte prosím v žiadosti vyššie všetky povinné údaje a vyhlásenia."); return; }
    setSubmitting(true);
    try {
      if (form) await axios.post(`${API}/applicant/application`, form.f, auth);
      await axios.post(`${API}/applicant/submit-application`, {}, auth);
      setSubmitted(true);
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Odoslanie zlyhalo. Skontrolujte údaje v žiadosti.");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="border border-[#D4AF37]/30 bg-[#0a0a0a] p-6 mb-8" data-testid="portal-submit-application">
      <div className="flex items-center gap-2 mb-1">
        <Send size={18} className="text-[#D4AF37]" />
        <h3 className="font-display text-xl">{t.signSubmit || "Odoslať kompletnú žiadosť"}</h3>
      </div>
      <p className="text-white/40 text-sm mb-5">{t.submitFinalHint || "Posledný krok — po podpísaní všetkých dokumentov a pridaní príloh odošlite kompletnú žiadosť."}</p>

      {err && <p className="text-red-400 text-sm mb-4" data-testid="submit-error">{err}</p>}

      {submitted ? (
        <div className="flex items-start gap-3 border border-green-500/30 bg-green-500/10 px-4 py-4 rounded-md" data-testid="sign-submitted">
          <Check size={18} className="text-green-400 shrink-0 mt-0.5" />
          <p className="text-white/85 text-sm">{t.signSubmitted || "Ďakujeme! Vaša kompletná žiadosť bola odoslaná značke profesionality a odbornosti SauberEko®. Budeme Vás kontaktovať."}</p>
        </div>
      ) : (
        <>
          <label className={`flex items-start gap-3 mb-4 ${allSigned ? "cursor-pointer" : "opacity-50 cursor-not-allowed"}`}>
            <input type="checkbox" checked={confirmed} disabled={!allSigned}
              onChange={(e) => setConfirmed(e.target.checked)} data-testid="sign-confirm-checkbox"
              className="mt-0.5 h-4 w-4 accent-[#D4AF37]" />
            <span className="text-white/75 text-sm leading-relaxed">
              {t.signConfirm || "Potvrdzujem, že som si všetky dokumenty otvoril, prečítal a podpísal, a oboznámil som sa s ich obsahom."}
            </span>
          </label>
          <button onClick={submitApplication} disabled={!allSigned || !confirmed || submitting}
            data-testid="sign-submit-button"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-semibold px-6 py-3 text-sm rounded hover:bg-[#F2E3C6] transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
            {submitting ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />}
            {t.signSubmit || "Odoslať kompletnú žiadosť"}
          </button>
          {!allSigned && (
            <p className="text-white/40 text-xs mt-3">{t.signAllToSubmit || "Najprv otvorte, prečítajte a podpíšte všetky dokumenty vyššie."}</p>
          )}
        </>
      )}
    </div>
  );
}
